<header class="ba-content-header">
  <div class="ba-content-wrap">
    <h1 id="ZMF_Header_Title"
    data-testid="header-zusammenfassung">{{'ANTRAGSSTRECKE.ABSCHLUSS_TITEL' | translate}}</h1>
  </div>
</header>

<div class="container-fluid">
  <form [formGroup]="form">
    <p class="ba-required-hint">Bitte alle mit * markierten Felder ausfüllen</p>
    @if (showFehler) {
      <div
        aria-atomic="true"
        class="alert alert-error"
        id="Fehler_Box"
        role="alert">
        @if (isFachlicherFehler) {
          <h2 class="h4" id="ZF_Fachlicher_Fehler_Box_Title">Fachlicher Fehler</h2>
          <p id="ZF_Fachlicher_Fehler_Box_Text">
            Teile des Antrags sind unvollständig, fehlerhaft oder es existieren offene Entwürfe. Bitte folgen Sie den nachfolgenden Links und korrigieren Sie Ihre Eingaben oder schließen offene Entwürfe ab.
          </p>
          @if (routeInfos?.length > 0) {
            <div>
              <ul>
                @for (routeInfo of routeInfos; track routeInfo) {
                  <li>
                    @if (routeInfo) {
                      <a [routerLink]=routeInfo.link  [queryParams]="{ id: antragId, v: wbaAntragVersion }">{{ routeInfo.label }}</a>
                    }
                  </li>
                }
              </ul>
            </div>
          }
          <div [innerText]="fachlicheFehler"></div>
        } @else {
          <h2 class="h4" id="ZF_Technischer_Fehler_Box_Title">{{titleTechnischerFehler}}</h2>
          @if (isAllgemeinerTechnischerFehler) {
            <p id="ZF_Technischer_Fehler_Box_Text" >
              Es ist ein technischer Fehler aufgetreten. Der Service ist momentan leider nicht verfügbar. Bitte versuchen Sie es später erneut.
            </p>
          } @else {
            <p>
              Aufgrund eines technischen Problems konnte Ihr Antrag nicht abgesendet werden, da Ihre hochgeladenen Dokumente nicht korrekt verarbeitet wurden. Bitte löschen Sie daher alle hochgeladenen Dokumente und laden Sie diese erneut hoch. Beginnen Sie auf der Seite <a [routerLink]="['/wba/vorabfragen/bedarfsgemeinschaft']"  [queryParams]="{ id: antragId, v: wbaAntragVersion }">Bedarfsgemeinschaft</a>. Senden Sie anschließend den Antrag nochmals ab.
            </p>
          }
        }
      </div>
    }

    <geo-panel [count]="1" id="Zusammenfassung">
      <span panel-title id="ZMF_Main_Title">Vorschau</span>
      <h3 class="h6 mb-2"
        id="ZMF_Vorschau_Subitle">
        Bitte prüfen Sie Ihre Angaben.
      </h3>
      <span id="ZMF_Vorschau_Descrition">Nachfolgend wird Ihnen ein Vorschaudokument angezeigt. Bitte überprüfen Sie alle Angaben gründlich. Fehlende oder falsche Angaben können zu Rückfragen und Verzögerungen bei der Bearbeitung führen. Um Angaben zu vervollständigen oder zu korrigieren, klicken Sie bitte auf den Button ZURÜCK und nehmen Sie entsprechende Änderungen/ Ergänzungen vor.</span>
      <ul class="ba-linklist pt-2">
        <li>
          <wba-download-link [url]="'antrag/'+(antrag$ | async)?.id+'/vorschau'"
            _id="ZMF_Vorschau_Download_PDF_lnk"
            fileName="Weiterbewilligungsantrag.pdf"
            ariaLabel="Vorschau Ihrer Angaben zur Weiterbewilligung als PDF herunterladen"
            piwikTitle="Vorschau Ihrer Angaben">
            Vorschau Ihrer Angaben zur Weiterbewilligung (PDF)
          </wba-download-link>
        </li>
        @if ((antrag$ | async).antragsteller.bedarfsgemeinschaft.hatUmzug) {
          <li>
            <wba-download-link [url]="'anlage_kdu/'+(antrag$ | async)?.id+'/vorschau'"
              _id="ZMF_Vorschau_Download_KDU_lnk"
              fileName="Kosten_der_Unterkunft.pdf"
              ariaLabel="Vorschau Ihrer Angaben zu den Kosten der neuen Unterkunft als PDF herunterladen"
              piwikTitle="[ZFS] Vorschau Ihrer Angaben zu den Kosten der neuen Unterkunft">
              Vorschau Ihrer Angaben zu den Kosten der neuen Unterkunft (PDF)
            </wba-download-link>
          </li>
        }
        @for (mitglied of mitglieder$ | async; track mitglied) {
          <li>
            <wba-download-link [url]="'anlage_ek/'+(antrag$ | async)?.id+'/' + mitglied.id + '/vorschau'"
              _id="ZMF_Vorschau_Download_EK_lnk"
              fileName="Einkommen_{{mitglied.name.replaceAll(' ', '_')}}.pdf"
              ariaLabel="Vorschau Ihrer Angaben zum Einkommen für {{mitglied.name}} als PDF herunterladen"
              piwikTitle="[ZFS] Vorschau Ihrer Angaben zum Einkommen">
              Vorschau Ihrer Angaben zum Einkommen für {{mitglied.name}} (PDF)
            </wba-download-link>
          </li>
        }
      </ul>
    </geo-panel>

    <geo-panel [count]="2" id="anlage_vm">
      <span panel-title id="anlage_vm_Title">Hinweis zur Anlage VM</span>
      <section>
        <p id="anlage_vm_hinweis">
          Bitte beachten Sie, dass für Bewilligungszeiträume ab dem 01.07.2026 verpflichtend eine Anlage VM ausgefüllt und eingereicht werden muss.
          Diese ist für die weitere Bearbeitung Ihres Antrages notwendig.
        </p>
      </section>
    </geo-panel>

    <geo-panel [count]="3" id="bildung_und_teilhabe">
      <span panel-title id="bildung_und_teilhabe_Title">Hinweis zur Bildung und Teilhabe</span>
      <section>
        <p id="bildung_und_teilhabe_hinweis">
          Beachten Sie bitte, dass Personen unter 25 BildungJahren einen Anspruch auf Leistungen für Bildung und
          Teilhabe haben
          können
          (§&nbsp;28 Zweites Buch Sozialgesetzbuch). Diese Leistungen umfassen zum Beispiel die
          gemeinschaftliche
          Mittagsverpflegung,
          den persönlichen Schulbedarf und Zuschüsse zu Vereinsbeiträgen. Eine Prüfung der
          Anspruchsvoraussetzungen erfolgt
          bereits ab Antragstellung des Grundsicherungsgeldes. Ein gesonderter Antrag ist nur für den Bedarf für
          zusätzliche
          Lernförderung
          notwendig.
        </p>
        <p> Für Kinder ab 15 Jahren reichen Sie bitte grundsätzlich eine Schulbescheinigung ein.
          Weitere Informationen zu diesen Leistungen erhalten Sie bei Ihrem Jobcenter oder dem zuständigen
          kommunalen Träger.
        </p>
      </section>
    </geo-panel>

    <geo-panel [count]="4" id="Erforderliche Erklärung">
      <span panel-title
        id="ZMF_PassedSent_Title">{{'ANTRAGSSTRECKE.ERFORDERLICHE_ERKLAERUNG' | translate}}
      </span>
      <p [attr.id]="ZMF_PASSEDSENT_TEXT_IDS[0]"
        class="ba-copytext">
        <div>
          <h3 class="h6 mb-2" [attr.id]="ZMF_PASSEDSENT_TEXT_IDS[2]">
          Rückwirkung des Antrags auf den Ersten des Monats:</h3>
          <p [attr.id]="ZMF_PASSEDSENT_TEXT_IDS[3]">
            Ich weiß, dass mein Antrag in der Regel auf den Ersten des Monats zurückwirkt (§ 37 Absatz 2 Satz 2 Zweites
            Buch
            Sozialgesetzbuch (SGB II))
            und ich deshalb Angaben – insbesondere zum Zufluss von Einkommen – für den kompletten Monat meiner
            Antragstellung machen muss.
          </p>
          <h3 class="h6 mb-2" [attr.id]="ZMF_PASSEDSENT_TEXT_IDS[4]">Kenntnisnahme der Datenverarbeitung:</h3>
          <p [attr.id]="ZMF_PASSEDSENT_TEXT_IDS[5]">
            Ich nehme zur Kenntnis, dass die Datenverarbeitung auf der Grundlage der sozialgesetzlichen Vorschriften
            für die Erhebung nach § 67a Absatz 1 Zehntes Buch Sozialgesetzbuch (SGB X) bzw. Speicherung und Nutzung nach § 67c Absatz 1 SGB X in
            Verbindung mit Artikel 6 Absatz 1 lit. e Datenschutzgrundverordnung erfolgt.
          </p>
          <h3 class="h6 mb-2">Datenschutzrechtliche Hinweise:</h3>
          <p class="ba-copytext">Datenschutzrechtliche Hinweise erhalten Sie bei dem für Sie zuständigen Jobcenter sowie ergänzend
            im Internet unter
            <a
              href="http://www.arbeitsagentur.de/datenerhebung"
              id="link-arbeitsagentur"
              target="_blank">
            www.arbeitsagentur.de/datenerhebung.</a>
          </p>

          <wba-versioned-text-block [wbaAntragVersion]="wbaAntragVersion">
            <ng-container wbaVersionAlt>
              <p [attr.id]="ZMF_PASSEDSENT_TEXT_IDS[6]"><b>Meine Mitwirkungspflichten:</b></p>
              <p [attr.id]="ZMF_PASSEDSENT_TEXT_IDS[7]">
                Ich weiß, dass ich mitwirkungspflichtig bin, wenn ich Leistungen nach dem SGB II beantrage oder
                erhalte.
                Das bedeutet, <b>alle Angaben</b> im Antrag und in den hierzu eingereichten Anlagen <b>müssen richtig
                und
              vollständig</b> sein.
              Änderungen, die nach der Antragstellung eintreten und sich auf die Leistungen auswirken können (zum
              Beispiel Arbeitsaufnahme, Umzug),
              sind dem zuständigen Jobcenter unverzüglich mitzuteilen. Die Mitwirkungspflichten sind von allen
              Mitgliedern meiner Bedarfsgemeinschaft zu beachten.
            </p>
            <br>
              <p [attr.id]="ZMF_PASSEDSENT_TEXT_IDS[8]"><b>Verstoß gegen die Mitwirkungspflichten:</b></p>
              <p [attr.id]="ZMF_PASSEDSENT_TEXT_IDS[9]">
                Ich weiß, dass bei einem Verstoß gegen diese Mitwirkungspflichten in
                aller Regel von allen leistungsberechtigten Personen meiner Bedarfsgemeinschaft zu viel gezahlte
                Leistungen zurückgefordert werden. Sofern zu meiner Bedarfsgemeinschaft noch weitere Personen
                gehören, sollte ich als Vertreterin/Vertreter beim Ausfüllen des Antrags alle Mitglieder einbeziehen
                und
                die wesentlichen sowie die sie betreffenden Angaben mit ihnen abstimmen. Ich stelle zudem sicher, dass
                alle Mitglieder alle notwendigen Informationen (zum Beispiel Bescheide) erhalten.
              </p>
              <p [attr.id]="ZMF_PASSEDSENT_TEXT_IDS[10]">
                Ich weiß, dass ein Verstoß gegen diese Mitwirkungspflichten zusätzlich zu einem
                <b>Ordnungswidrigkeiten- oder Strafverfahren</b> gegen die Person führen kann, die die
                oben genannten Pflichten missachtet hat.
                Das Jobcenter holt im Wege eines automatisierten Datenabgleichs bei verschiedenen Stellen
                Auskünfte über Einkommen und Vermögen ein (zum Beispiel Arbeitsentgelte, Kapitalerträge, Renten).
                Verschwiegene Einkommen und Vermögen werden daher regelmäßig nachträglich bekannt.
              </p>
            </ng-container>

            <ng-container wbaVersionAktuell>
              <h3 class="h6 mb-2" [attr.id]="ZMF_PASSEDSENT_TEXT_IDS[6]">Meine Mitwirkungspflichten:</h3>
              <p [attr.id]="ZMF_PASSEDSENT_TEXT_IDS[7]">
                Personen, die Leistungen nach dem SGB II beantragen oder erhalten, sind mitwirkungspflichtig:
                Das bedeutet, alle Angaben im Antrag und in den hierzu eingereichten Anlagen müssen richtig und
                vollständig sein. Änderungen, die nach der Antragstellung eintreten und sich auf die Leistungen
                auswirken können (z. B. Arbeitsaufnahme, Umzug), sind dem zuständigen Jobcenter <b>unverzüglich</b> mitzuteilen.
                Die Mitwirkungspflichten sind <b>von allen Mitgliedern einer Bedarfsgemeinschaft</b> zu beachten.
              </p>
              <div class="ba-collapsible">
                <button #button
                  class="ba-collapse-control collapsed collapse-btn-correction"
                  aria-controls="collapse1"
                  aria-label="Mehr erfahren zu Thema XY"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse1"
                  type="button"
                  data-label-collapsed="Mehr erfahren zu Thema XY"
                  data-label-expanded="Weniger anzeigen zu Thema XY">
                  <span class="ba-collapse-open">Mehr erfahren</span>
                  <span class="ba-collapse-close">Weniger anzeigen</span>
                </button>
                <div class="collapse"
                  id="collapse1"
                  role="tabpanel"
                  aria-label="Titel des optionalen Abschnitts">
                  <div class="ba-copytext pb-2">
                    <p>Bei Verstoß gegen diese Mitwirkungspflichten werden in aller Regel von allen leistungsberechtigten
                      Personen einer Bedarfsgemeinschaft <b>zu viel gezahlte Leistungen zurückgefordert.</b> Sofern zu Ihrer
                      Bedarfsgemeinschaft noch weitere Personen gehören, sollten Sie als Vertreterin/Vertreter beim
                      Ausfüllen des Antrags alle Mitglieder einbeziehen und die wesentlichen sowie die sie betreffenden
                      Angaben mit ihnen abstimmen. Stellen Sie zudem bitte sicher, dass alle Mitglieder alle notwendigen
                      Informationen (z. B. Bescheide) erhalten.
                      <br><br>
                      Ein Verstoß gegen die Mitwirkungspflichten kann zusätzlich zu einem <b>Ordnungswidrigkeiten- oder
                    Strafverfahren</b> gegen die Person führen, die die oben genannten Pflichten missachtet hat. Das
                    Jobcenter holt im Wege eines automatisierten Datenabgleichs bei verschiedenen Stellen Auskünfte
                    über Einkommen und Vermögen ein (z. B. Arbeitsentgelte, Kapitalerträge, Renten). Verschwiegene
                  Einkommen und Vermögen werden daher regelmäßig nachträglich bekannt.</p>
                </div>
              </div>
            </div>
          </ng-container>
        </wba-versioned-text-block>
      </div>
      <br>
        <wba-input-checkbox _id="id-2"
          errorLabel="Bestätigung der gemachten Angaben"
          formControlName="checkbox1"
          name="erklaerung"
          dataAnalyticsName="erklaerung"
          title="Hiermit bestätige ich, dass alle von mir gemachten Angaben richtig und vollständig sind"
          required="true">
          Hiermit bestätige ich, dass alle von mir gemachten Angaben richtig sind.
        </wba-input-checkbox>
      </geo-panel>

      <div class="row ba-form-row">
        <wba-button-leiste (clickLeft)="zurueck()"
          (clickRight)="senden()"
          [btnRightDisabled]="pending || this.form.invalid"
          [btnRightLabel]="'COMMON.BUTTON.ANTRAG_SENDEN' | translate"
          btnLeftId="ZMF_zurueck_btn"
          dataAnalyticsNameRight="Antrag senden"
          dataAnalyticsNameLeft="Zurück zu Weitere Änderungen"
          btnRightId="ZMF_senden_btn"/>
      </div>

      <wba-antrag-spaeter-fortsetzen dataAnalyticsName="Antrag später fortsetzen Zusammenfassung"
        _id="ZMF_Main"/>
    </form>
  </div>
